import AnonymousStorage from './AnonymousStorage';

const clearTodosAnonymousService = (db: AnonymousStorage) => async () => {
  await db.todos.clear();
};

export default clearTodosAnonymousService;
